import IdAndName from "../../../types/report/IdAndName";
import NumberType from "../../../types/report/NumberType";

const sortingHelper = {
    sortByNumberAsc: (collection: NumberType[]) => collection.sort((x, y) => { return x.number > y.number ? 1 : x.number < y.number ? -1 : 0; }),
    sortByNumberDesc: (collection: NumberType[]) => collection.sort((x, y) => { return x.number < y.number ? 1 : x.number > y.number ? -1 : 0; }),
    sortByNameAsc: (collection: IdAndName[]) => collection.sort((x, y) => { return x.name > y.name ? 1 : x.name < y.name ? -1 : 0; })
};

export default sortingHelper;